import { render, staticRenderFns } from "./GroupSessionTypeCrudItem.vue?vue&type=template&id=68f62748&scoped=true&"
import script from "./GroupSessionTypeCrudItem.vue?vue&type=script&lang=js&"
export * from "./GroupSessionTypeCrudItem.vue?vue&type=script&lang=js&"
import style0 from "./GroupSessionTypeCrudItem.vue?vue&type=style&index=0&id=68f62748&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f62748",
  null
  
)

export default component.exports